import { render, staticRenderFns } from "./Imposto.vue?vue&type=template&id=e463c884&scoped=true&"
import script from "./Imposto.vue?vue&type=script&lang=js&"
export * from "./Imposto.vue?vue&type=script&lang=js&"
import style0 from "./Imposto.vue?vue&type=style&index=0&id=e463c884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e463c884",
  null
  
)

export default component.exports